<template>
  <div class="boot-trainers">
    <weui-search-bar placeholder="搜索会员" v-model.trim="query" />
    <sidebar :keys="keys" @click-key="scrollTo" />

    <weui-group v-if="!query">
      <trainer-cell :trainer="virtual_trainer_coach" :selecting="true" :virtual="true" @click="createCoachCourse">
        <template slot="subtitle">{{ virtual_trainer_coach.description }}</template>
      </trainer-cell>
      <trainer-cell :trainer="virtual_trainer_private" :selecting="true" :virtual="true" @click="createPrivateCourse">
        <template slot="subtitle">{{ virtual_trainer_private.description }}</template>
      </trainer-cell>
    </weui-group>

    <weui-group title="最近安排过的会员" v-if="!query && Array.isArray(usedTrainers) && usedTrainers.length">
      <trainer-cell v-for="t in usedTrainers" :key="t.id" :trainer="t" :selecting="true" @click="selectTrainer(t)" />
    </weui-group>

    <trainer-group v-for="(trainers, key) in groupedTrainers" :key="key" :title="key" :ref="`key_${key}`">
      <trainer-cell v-for="t in trainers" :key="t.id" :trainer="t" :selecting="true" @click="selectTrainer(t)" />
    </trainer-group>

    <router-link role="button" class="create" :to="{ name: ROUTE_TRAINER_CREATE }">
      <div class="symbol">+</div>
      <div class="create-text">新增会员</div>
    </router-link>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash.debounce';
import { WeuiSearchBar, WeuiGroup } from '@/components/weui';
import Sidebar from '@/components/trainer/Sidebar';
import TrainerGroup from '@/components/trainer/TrainerGroup';
import TrainerCell from '@/components/trainer/TrainerCell';

import { FETCH_GROUPED_TRAINERS } from '@/store/trainer/types';
import { COURSE_DRAFT_INITIALIZE, COURSE_DRAFT_FILL } from '@/store/course/types';
import { COURSE_TYPE_TRAINER, COURSE_TYPE_COACH, COURSE_TYPE_PRIVATE } from '@/constants/types';
import { ROUTE_COURSE_CREATE, ROUTE_TRAINER_CREATE } from '@/router/names';

const { mapState: mapCoachState } = createNamespacedHelpers('coach');
const { mapState: mapCourseState, mapMutations: mapCourseMutations } = createNamespacedHelpers('course');
const { mapState: mapTrainerState, mapActions: mapTrainerActions } = createNamespacedHelpers('trainer');

export default {
    data() {
        return {
            ROUTE_TRAINER_CREATE,
            query: '',
        };
    },
    computed: {
        ...mapCoachState({
            coach: state => state.coach || {},
        }),
        ...mapCourseState({
            usedTrainerIds: state => state.used_trainers || {},
        }),
        ...mapTrainerState({
            groupedTrainers: state => state.grouped || {},
        }),
        usedTrainers() {
            const trainerss = Object.values(this.groupedTrainers);
            const trainers = this.usedTrainerIds.map((id) => {
                for (let i = 0; i < trainerss.length; i += 1) {
                    for (let j = 0; j < trainerss[i].length; j += 1) {
                        if (trainerss[i][j].id === id) {
                            return trainerss[i][j];
                        }
                    }
                }

                return null;
            });

            return trainers.filter(t => t !== null);
        },
        keys() {
            return Object.keys(this.groupedTrainers);
        },
        virtual_trainer_coach() {
            return {
                wechat_bound: true,
                avatar: this.coach.avatar,
                name: '自己训练',
                description: '教练自己也需要保持体形哦',
            };
        },
        virtual_trainer_private() {
            return {
                wechat_bound: true,
                avatar: this.coach.avatar,
                name: '私人事件',
                description: '私事也可以记录进来',
            };
        },
    },
    watch: {
        watch: {
            // eslint-disable-next-line func-names
            query: debounce(function (newVal) {
                this.fetchGroupedTrainers({
                    query: newVal,
                });
            }, 200),
        },
    },
    created() {
        this.initializeDraft();
        this.fetchGroupedTrainers();

        const { date } = this.$route.query;
        if (date) {
            this.fillDraft({ date });
        }
    },
    methods: {
        ...mapCourseMutations({
            initializeDraft: COURSE_DRAFT_INITIALIZE,
            fillDraft: COURSE_DRAFT_FILL,
        }),
        ...mapTrainerActions({
            fetchGroupedTrainers: FETCH_GROUPED_TRAINERS,
        }),
        scrollTo(payload) {
            const ele = this.$refs[`key_${payload.key}`];
            if (Array.isArray(ele)) {
                window.scrollTo(0, ele[0].$el.offsetTop);
            }
        },
        createCoachCourse() {
            this.fillDraft({
                type: COURSE_TYPE_COACH,
            });
            this.next();
        },
        createPrivateCourse() {
            this.fillDraft({
                type: COURSE_TYPE_PRIVATE,
            });
            this.next();
        },
        selectTrainer(trainer) {
            this.fillDraft({
                type: COURSE_TYPE_TRAINER,
                trainer_id: trainer.id,
            });
            this.next();
        },
        next() {
            this.$router.replace({
                name: ROUTE_COURSE_CREATE,
            });
        },
    },
    components: {
        WeuiSearchBar,
        WeuiGroup,
        Sidebar,
        TrainerGroup,
        TrainerCell,
    },
};
</script>

<style lang="scss" scoped>
.boot-trainers {
    padding-bottom: 18.666666666vw;
}

.create {
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 13.333333333vw;
    display: flex;
    align-items: center;
    text-align: center;
    z-index: 100;

    .symbol {
        width: 20vw;
        flex: none;
        background-color: white;
        color: #ff7245;
        font-size: 8.533333333vw;
        line-height: 1.5625;
    }

    .create-text {
        flex: auto;
        background-color: #ff7245;
        color: white;
        font-size: 6.4vw;
        line-height: 13.333333333vw;
    }
}
</style>



// WEBPACK FOOTER //
// src/containers/course/BootTrainers.vue